import React, { useEffect, useState } from 'react';
import numeral from 'numeral';
import _ from 'lodash';
import classnames from 'classnames';
import RadioComponent from 'shared/components/RadioComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';


const PriceMatrixCell = (props) => {
  const {
    lineItem,
    quantity,
    leadTime,
    parameters,
    onPriceSelect,
    name,
    inputClassName,
    restrictedPrice,
  } = props;

  const [row, setRow] = useState();
  const [col, setCol] = useState();
  const [totalPrice, setTotalPrice] = useState();
  const [isSelected, setSelected] = useState();
  const [unitPrice, setUnitPrice] = useState();
  const [displayUnitPrice, setDisplayUnitPrice] = useState();
  const [identifier, setIdentifier] = useState();
  const [isRestricted, setRestricted] = useState();

  useEffect(() => {
    const supplier = lineItem.product_key;
    let currentRow = null;
    let currentCol = null;
    let currentTotalPrice = null;
    let currentUnitPrice = null;
    let currentDisplayUnitPrice = null;
    let selected = false;

    if (!lineItem || !quantity) {
      currentRow = -1;
      currentCol = -1;
    } else {
      currentRow = lineItem.quantities.indexOf(quantity);
      currentCol = lineItem.lead_times.indexOf(leadTime);

      const { pricing } = lineItem;
      if (pricing === undefined ||
        currentRow < 0 ||
        currentCol < 0 ||
        pricing[currentRow] === undefined ||
        pricing[currentRow][currentCol] === undefined
      ) {
        currentTotalPrice = null;
      } else {
        if (parameters.supplier_selected) {
          selected = _.parseInt(parameters.row_selected) === currentRow
            && _.parseInt(parameters.column_selected) === currentCol
            && parameters.supplier_selected === supplier;
        } else {
          selected = _.parseInt(parameters.row_selected) === currentRow
            && _.parseInt(parameters.column_selected) === currentCol;
        }

        currentTotalPrice = pricing[currentRow][currentCol];
        currentUnitPrice = Math.round((currentTotalPrice / quantity) * 100) / 100;
        currentDisplayUnitPrice = numeral(currentUnitPrice).format('0.00');
      }
    }

    setSelected(selected);
    setRow(currentRow);
    setCol(currentCol);
    setRestricted((isManager && restrictedPrice) ? restrictedPrice[currentRow][currentCol] : false);
    setTotalPrice(currentTotalPrice);
    setUnitPrice(currentUnitPrice);
    setDisplayUnitPrice(currentDisplayUnitPrice);
    setIdentifier(`${quantity}-${leadTime}${supplier ? `-${supplier}` : ''}'}`);
  }, [lineItem, quantity]);

  useEffect(() => {
    const isCurrentRowSelected = _.parseInt(parameters.row_selected) === row;
    const isCurrentColSelected = _.parseInt(parameters.column_selected) === col;
    const isSupplierSelected = parameters.supplier_selected ? parameters.supplier_selected === lineItem.product_key : true;

    setSelected(isCurrentRowSelected && isCurrentColSelected && isSupplierSelected);
  }, [
    lineItem,
    parameters.supplier_selected,
    parameters.row_selected,
    parameters.column_selected,
    row,
    col,
  ]);

  if (!totalPrice || !(totalPrice > 0)) return (<td />);

  return (
    <td className={classnames(isSelected && 'price-active')}>
      <RadioComponent
        inputId={`price${identifier}`}
        label={
          <div className="d-flex align-items-center">
            {isRestricted && (<FontAwesomeIcon className="mr-2" icon={faExclamationCircle} />)}
            {displayUnitPrice}
          </div>
        }
        checked={isSelected}
        name={name}
        groupName={null}
        inputClassName={inputClassName}
        inline
        onChange={() => {
          onPriceSelect({
            quantity,
            leadTime,
            unitPrice,
            row_selected: row,
            column_selected: col,
            supplier: lineItem.product_key,
          });
        }} />
    </td>
  );
};

PriceMatrixCell.defaultProps = {
  inputClassName: 'price-radio',
};

export default PriceMatrixCell;
